import React from 'react'
 import useSEO from "./useSEO";
const Interiordesign = () => {
  useSEO({ 
  title: "Interior Design in Hyderabad | Residential & Commercial Interior Solutions",
  description: "Expert interior design services in Hyderabad offering creative, functional, and customized solutions for homes, offices, and commercial spaces. Transform your interiors with our professional designers.",
  keywords: "interior design Hyderabad, home interior Hyderabad, office interior Hyderabad, commercial interior design Hyderabad, interior decorators Hyderabad, modular kitchen Hyderabad, luxury interiors Hyderabad, residential interior Hyderabad, space planning Hyderabad",
  ogTitle: "Interior Design in Hyderabad - Creative & Functional Spaces",
  ogDescription: "Transform your home or office with our expert interior design services in Hyderabad. Stylish, functional, and tailored to your needs.",
  ogImage: "img/interior-design.png",
  twitterTitle: "Interior Design in Hyderabad - Creative & Functional Spaces",
  twitterDescription: "Professional residential and commercial interior design services in Hyderabad for stylish and functional living.",
  twitterImage: "img/interior-design.png"
});

  return (
    <div>
      <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> Interior Design </h1>
          <p className="mb-4">
            {" "}
            Interior design is more than aesthetics — it’s about creating
            functional, inspiring, and personalized environments that reflect
            your style and purpose. Whether it's a home, office, retail space,
            or hospitality setting, great design enhances how people live, work,
            and feel.
          </p>
          <p className="mb-4">
            {" "}
            Our expert interior design services combine creativity,
            functionality, and attention to detail to bring your vision to life.
            From concept to completion, we work closely with you to deliver
            spaces that are beautiful, practical, and perfectly aligned with
            your needs.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img src="img/interior-design.png" alt="Interior Design" />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            {" "}
            <img src="img/interior-design1.png" alt="Interior Design" />{" "}
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> Key Features:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Residential Interiors: </b>
                </li>
                <p>
                  {" "}
                  Personalized home interiors — including living rooms,
                  bedrooms, kitchens, and modular wardrobes — that balance
                  comfort and style.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Commercial &amp; Office Spaces:</b>
                </li>
                <p>
                  {" "}
                  Smart layouts, ergonomic furniture, and modern aesthetics
                  designed to improve productivity and make lasting impressions.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Retail &amp; Showroom Design: </b>
                </li>
                <p>
                  {" "}
                  Engaging store layouts that highlight products and enhance the
                  customer experience.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Turnkey Interior Projects:</b>
                </li>
                <p>
                  {" "}
                  End-to-end execution from design planning, material selection,
                  and project management to final setup and delivery.{" "}
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> 3D Visualization &amp; Space Planning:</b>
                </li>
                <p>
                  {" "}
                  Detailed 3D renders and layouts to help you visualize the
                  space before execution.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Custom Furniture &amp; Decor:</b>
                </li>
                <p>
                  {" "}
                  Tailor-made furniture, lighting, and decor elements crafted to
                  match the theme and function of your space.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

    </div>
  )
}

export default Interiordesign
